export default function absRound(number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/abs-round.js
// module id = 288
// module chunks = 0